<bn-loading-overlay></bn-loading-overlay>

<h5>Posição da Carteira em Recuperação de Crédito</h5>
<div class="container" >
  <form class="mt-3 mx-auto" [formGroup]="pesquisaForm" *ngIf="pesquisaForm" (keyup.enter)="buscar()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/acompanhamento-processual/cadastro']" placement="bottom"
          ngbTooltip="Tela para cadastro de posição da carteira em recuperação de crédito." [disabled]="!podeEnviar"><i class="fa fa-file-signature">
          </i> Cadastrar via tela</button>
      </div>      
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" (click)="downloadOperacoesQuePrecisamSerInformadas()" placement="bottom"
          ngbTooltip="Tela para download de arquivo com as operações que precisam ser informadas." [disabled]="!podeListarOperacoes || !agenteFinanceiroSelecionado()"><i class="fa fa-download">
          </i> Operações que precisam ser informadas</button>
      </div>      
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" autofocus (click)="buscar()" [disabled]="!pesquisaForm.valid"
        >Pesquisar</button>
      </div>
    </div>

    <div class="mb-3 row" >
      <div class="col-md-6">
        <label class="form-label">Agente Financeiro:</label>
        <select  class="form-select" id="cnpjAgenteFinanceiro" name="cnpjAgenteFinanceiro" formControlName="cnpjAgenteFinanceiro" >
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of agentesFinanceiros" [ngValue]="item.cnpj">{{ item.nome }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Data de envio inicial:</label>
        <bn-datepicker idInput="dataEnvioInicial" name="dataEnvioInicial"  formControlName="dataEnvioInicial" >
        </bn-datepicker>
      </div>
      <div class="col-md-3">
          <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
          <bn-datepicker idInput="dataEnvioFinal"  name="dataEnvioFinal"  formControlName="dataEnvioFinal">
          </bn-datepicker>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusProtocolo">Status Protocolo: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [selected]="true" [ngValue]="null">Todos</option>
          <option *ngFor="let status of valoresStatusProtocolo" [ngValue]="status.codigo">{{ status.label }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select class="form-select" name="sistema" formControlName="sistema">
          <option [value]=null>Todos</option>
          <option value='CL'>Crédito Livre</option>
          <option value='15'>15 - Contratos FINAME</option>
          <option value='89'>89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input type="text" class="form-control" id="idExternoOperacao" name="idExternoOperacao" formControlName="idExternoOperacao">
      </div>

      <div class="col-md-3">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input type="text" class="form-control" id="contrato" name="contrato" formControlName="contrato">
      </div>
    </div>
  </form>  
</div>

<acompanhamento-processual-listagem *ngIf="pesquisado"
  [hidden]="esconderPesquisa"
  [agentesFinanceiros]="agentesFinanceiros"
  [acompanhamentosOperacao]="acompanhamentosOperacao"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem" 
  [ehAgenteFinanceiro]="ehAgenteFinanceiro" 
  (aoMudarPagina)="mudancaPagina($event)"
></acompanhamento-processual-listagem>
